module.exports = global["_"] = require("-!C:\\actions_runner\\_work\\escapia-ownerportal\\escapia-ownerportal\\Solutions\\op\\Owner.Portal\\node_modules\\expose-loader\\index.js?underscore!.\\index.js");


//////////////////
// WEBPACK FOOTER
// ./~/lodash/index.js
// module id = 37
// module chunks = 0